import { html, el } from '../html.js';
import { screen } from '../shell.js';
import { api } from '../api.js';
import { go } from '../router.js';

export async function editView({ id }) {
  const p = await api('GET', `/api/places/${id}`);
  const s = screen({ back: true });
  const form = el(html`<form class="stack" novalidate>
    <h1>Edit place</h1>
    <label class="field"><span>Name</span><input name="name" required maxlength="80" value="${p.name}"></label>
    <p class="error" data-error="name" hidden>Give the place a name.</p>
    <label class="field"><span>Getting there</span><textarea name="gettingThere" maxlength="500">${p.gettingThere}</textarea></label>
    <label class="field"><span>Description</span><textarea name="description" maxlength="500">${p.description}</textarea></label>
    <label class="field"><span>Address</span><input name="address" maxlength="200" value="${p.address}"></label>
    <p class="error" role="alert" hidden></p>
    <button class="primary" type="submit">Save changes</button>
  </form>`);
  s.body.append(form);
  const field = name => form.querySelector(`[name=${name}]`).value.trim();
  form.addEventListener('submit', async e => {
    e.preventDefault();
    form.querySelector('[data-error=name]').hidden = !!field('name');
    if (!field('name')) return;
    const problem = form.querySelector('[role=alert]');
    try {
      await api('PATCH', `/api/places/${p.id}`, {
        name: field('name'), gettingThere: field('gettingThere'), description: field('description'), address: field('address'),
      });
      go(`/places/${p.id}`, 'Changes saved.', { replace: true });
    } catch (x) {
      problem.textContent = x.message;
      problem.hidden = false;
    }
  });
  return s.el;
}
